export class NetworkMonitor {

    //网络状态记录
    static isOnline: boolean | undefined;

    private static listeners: ((status: boolean) => void)[] = [];

    // 注册监听器的方法
    public static registerListener(listener: (status: boolean) => void): void {
        this.listeners.push(listener);
    }

    // 移除监听器的方法
    public static removeListener(listener: (status: boolean) => void): void {
        const index = this.listeners.indexOf(listener);
        if (index !== -1) {
            this.listeners.splice(index, 1);
        }
    }

    // 检查网络状态并通知所有监听器的方法
    public static checkNetworkStatus(): boolean {
        const online = navigator.onLine;
        if (this.isOnline == undefined || this.isOnline !== online) {
            this.isOnline = online;
            this.listeners.forEach(listener => listener(online));
        }
        return online;
    }
}